import { useEffect } from "react";
import { Hooks } from "../layout/utils/hooks";
import { useAppSelector } from "../redux/hooks";
import { GlobalHooks } from "../utils/Hooks";

const StatsDirectIntegrated = ({language , token}) => {
  const liveToken = useAppSelector((state) => state.LayoutReducer.STAT_LIVE_URL)
  const {cookies} = GlobalHooks()

  const OPTIONS = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Authorization" : "Bearer "+ cookies.authToken,
    },
  };

 
  const newStatsDirectIframe = "https:" +
    window.process.env.FO_STATS_URL + "/direct"
    +  "?lng=" + language + "&token=" + token
  
    return (
      <iframe
        id="iframe_statsDirect_display"
        src={newStatsDirectIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default StatsDirectIntegrated